module.exports = __webpack_public_path__ + "static/media/maintenance.2ab0d119.png";